interface Props {
  className?: string;
}

export default function TwinBedIcon({className}: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 41 20"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 7.557V0H16V2H4V0H2V7.557C0.81 8.25 0 9.525 0 11V15C0 15.2652 0.105357 15.5196 0.292893 15.7071C0.48043 15.8946 0.734784 16 1 16H2V20H4V16H16V20H18V16H19C19.2652 16 19.5196 15.8946 19.7071 15.7071C19.8946 15.5196 20 15.2652 20 15V11C20 9.525 19.189 8.25 18 7.557ZM4 4H16V7H4V4ZM18 14H2V11C2 9.897 2.897 9 4 9H16C17.103 9 18 9.897 18 11V14Z"
        fill="currentColor"
      />
      <path
        d="M39 7.557V0H37V2H25V0H23V7.557C21.81 8.25 21 9.525 21 11V15C21 15.2652 21.1054 15.5196 21.2929 15.7071C21.4804 15.8946 21.7348 16 22 16H23V20H25V16H37V20H39V16H40C40.2652 16 40.5196 15.8946 40.7071 15.7071C40.8946 15.5196 41 15.2652 41 15V11C41 9.525 40.189 8.25 39 7.557ZM25 4H37V7H25V4ZM39 14H23V11C23 9.897 23.897 9 25 9H37C38.103 9 39 9.897 39 11V14Z"
        fill="currentColor"
      />
    </svg>
  );
}
